import { SvgIcon, type SvgIconProps } from "@mui/material";
import { type FC, type PropsWithChildren } from "react";

const Package: FC<PropsWithChildren<SvgIconProps>> = (props) => (
    <SvgIcon {...props} viewBox="0 0 16 16">
        <path
            fillRule="evenodd"
            d="M15.25,11.6 C15.25,11.904 15.0808333,12.168 14.8230556,12.304 L8.45916667,15.856 C8.33027778,15.952 8.16916667,16 8,16 C7.83083333,16 7.66972222,15.952 7.54083333,15.856 L1.17694444,12.304 C0.919166667,12.168 0.75,11.904 0.75,11.6 L0.75,4.4 C0.75,4.096 0.919166667,3.832 1.17694444,3.696 L7.54083333,0.144 C7.66972222,0.048 7.83083333,0 8,0 C8.16916667,0 8.33027778,0.048 8.45916667,0.144 L14.8230556,3.696 C15.0808333,3.832 15.25,4.096 15.25,4.4 L15.25,11.6 Z M8,1.72 L6.4775,2.576 L11.2222222,5.288 L12.8011111,4.4 L8,1.72 Z M3.19888889,4.4 L8,7.08 L9.57888889,6.2 L4.84222222,3.48 L3.19888889,4.4 Z M2.36111111,11.128 L7.19444444,13.832 L7.19444444,8.464 L2.36111111,5.768 L2.36111111,11.128 Z M13.6388889,11.128 L13.6388889,5.768 L8.80555556,8.464 L8.80555556,13.832 L13.6388889,11.128 Z"
        />
    </SvgIcon>
);

export default Package;
